var map = {
	"./book.svg": 361,
	"./cake.svg": 617,
	"./chat-black.svg": 640,
	"./day-mode-black.svg": 273,
	"./day-mode-white.svg": 206,
	"./logo-black.svg": 140,
	"./logo-white.svg": 177,
	"./night-mode-white.svg": 999,
	"./play.svg": 758,
	"./soc-facebook-white.svg": 466,
	"./soc-facebook.svg": 37,
	"./soc-instagram-white.svg": 472,
	"./soc-instagram.svg": 584,
	"./soc-vimeo-white.svg": 18,
	"./soc-vimeo.svg": 222,
	"./volume-up.svg": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;